import { AuthUserType } from "../../../../../services/api/methodsTypes";
import { GenericSelect } from "../../../../../shared/components/AppGenericSelect";
import { multiUserApi } from "../../../../../shared/utils/multiUserFunctions";
import styles from "./styles.module.css";

interface Props {
  userList: AuthUserType[];
  user: AuthUserType;
}

export const UserSelect = ({ userList, user }: Props) => {
  const handleSelect = (value: AuthUserType | null) => {
    if (!value) return;
    multiUserApi.toggleUser(value.user_name);
    window.location.reload();
  };

  return (
    <GenericSelect<AuthUserType>
      options={userList}
      value={user}
      onChange={handleSelect}
      getLabel={(u) => u.user_name}
      getValue={(u) => u.user_name}
      className={styles["user-select"]}
    />
  );
};
